import { createFileRoute } from '@tanstack/react-router';
import { XNonFollowersPage } from '../../../pages/tools/x-non-followers/XNonFollowersPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/x-non-followers')({
  head: () => toolHead('x-non-followers'),
  component: XNonFollowersPage,
});
